import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import {
  type APIResponse,
  type MatterExpense,
  type SourceOwnedConnectionCreate,
} from "@/lib/types";
import { baseFastApiMatterRoute } from "./matter";

type MatterExpenseInput = Partial<Omit<MatterExpense, "connections">> & {
  matterId: string;
};

type CreateMatterExpenseInput = MatterExpenseInput & {
  connections?: SourceOwnedConnectionCreate[];
};

export const createMatterExpense = (data: CreateMatterExpenseInput) => {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<MatterExpense>>("matters/v4/expenses", data)
    .then((res) => res.data);
};

export const updateMatterExpense = (
  data: MatterExpenseInput & Pick<MatterExpense, "id" | "dateModified">,
) => {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<MatterExpense>
    >(`${baseFastApiMatterRoute}/expenses`, data)
    .then((res) => res.data);
};

export const deleteMatterExpense = (
  data: MatterExpenseInput & Pick<MatterExpense, "id">,
) => {
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterExpense>
    >(`${baseFastApiMatterRoute}/expenses/${data.id}`)
    .then((res) => res.data);
};
